import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Request from './Request';
export class ServiceConfig extends Request {
  constructor({
    agency,
    url,
    keycloak,
    signal
  }) {
    super({
      url,
      signal,
      keycloak
    });

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    _defineProperty(this, "getWidgetConfig", async params => {
      const response = await this.get({
        api: '/api/widgets/config',
        qs: params
      });
      return response;
    });

    _defineProperty(this, "saveWidgetConfig", async (configs, params) => {
      const response = await this.post({
        api: '/api/widgets/config',
        data: configs,
        method: 'PUT',
        qs: params
      });
      return response;
    });

    this.url = new URL(url);
    this.keycloak = keycloak;

    if (agency) {
      this.url.searchParams.append('agency', agency);
    }

    Object.defineProperty(this.commonHeaders, 'Authorization', {
      get() {
        const {
          token
        } = keycloak;
        return `Bearer ${token}`;
      },

      set() {// need a setter
      }

    });
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }

}
export default ServiceConfig;